import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/home/home.vue";
import About from "../views/about/about.vue";
import BestSellingStar from "../views/bestSellingStar/bestSellingStar.vue";
import Product from "../views/product/product.vue";
import ProductDetails from "../views/productDetails/productDetails.vue";
import contactUs from "../views/contactUs/contactUs.vue";
import termsOfUse from "../views/termsOfUse/termsOfUse.vue"
import MobileHome from "../views/mobileHome/mobileHome.vue";
import MobileAbout from "../views/mobileAbout/mobileAbout.vue";
import MobileBestSellingStar from "../views/mobileBestSellingStar/mobileBestSellingStar.vue";
import MobileProduct from "../views/mobileProduct/mobileProduct.vue";
import mobileContactUs from "../views/mobileContactUs/mobileContactUs.vue"
import mobileTermsOfUse from "../views/mobileTermsOfUse/mobileTermsOfUse.vue"

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/bestSellingStar",
    name: "BestSellingStar",
    component: BestSellingStar,
  },
  {
    path: "/product",
    name: "Product",
    component: Product,
  },
  {
    path: "/productDetails",
    name: "ProductDetails",
    component: ProductDetails,
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: contactUs,
  },
  {
    path: "/termsOfUse",
    name: "termsOfUse",
    component: termsOfUse
  },
  {
    path: "/mobileHome",
    name: "MobileHome",
    component: MobileHome,
  },
  {
    path: "/mobileAbout",
    name: "MobileAbout",
    component: MobileAbout,
  },
  {
    path: "/mobileBestSellingStar",
    name: "MobileBestSellingStar",
    component: MobileBestSellingStar,
  },
  {
    path: "/mobileProduct",
    name: "MobileProduct",
    component: MobileProduct,
  },
  {
    path: "/mobileContactUs",
    name: "mobileContactUs",
    component: mobileContactUs
  },
  {
    path: "/mobileTermsOfUse",
    name: "mobileTermsOfUse",
    component: mobileTermsOfUse
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
